import { render, staticRenderFns } from "./KnowledgeTable.vue?vue&type=template&id=6552c240&scoped=true&"
import script from "./KnowledgeTable.vue?vue&type=script&lang=js&"
export * from "./KnowledgeTable.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeTable.vue?vue&type=style&index=0&id=6552c240&lang=scss&scoped=true&"
import style1 from "./KnowledgeTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6552c240",
  null
  
)

export default component.exports